module.exports = DragonShared.dragonDesignMobile;